module.exports = __webpack_public_path__ + "img/home-bg.578bc0e2.png";